import React from 'react';
import clsx from 'clsx';

const ProfileImage = ({ colour }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='78' height='78' viewBox='0 0 78 78'>
      <g id='Group_3416' data-name='Group 3416' transform='translate(573.793 -2437.207)'>
        <circle id='Ellipse_461' data-name='Ellipse 461' cx='39' cy='39' r='39' transform='translate(-573.793 2437.207)' fill='#fffcf2'/>
        <path className={clsx({[`fill-${colour}`]:colour})} id='Subtraction_1' data-name='Subtraction 1' d='M45,22H0v-.065q0-.053,0-.106a21.134,21.134,0,0,1,1.768-8.5A21.634,21.634,0,0,1,3.843,9.624,22.144,22.144,0,0,1,6.59,6.393a22.586,22.586,0,0,1,7.152-4.678A23,23,0,0,1,35.08,3.728a22.528,22.528,0,0,1,3.33,2.665,22.143,22.143,0,0,1,2.747,3.231,21.634,21.634,0,0,1,2.075,3.708A21.134,21.134,0,0,1,45,21.828c0,.057,0,.114,0,.171h0Z' transform='translate(-556.793 2476.207)'/>
        <circle className={clsx({[`fill-${colour}`]:colour})} id='Ellipse_460' data-name='Ellipse 460' cx='11' cy='11' r='11' transform='translate(-545.793 2452.207)'/>
      </g>
    </svg>
  )
}

export default ProfileImage
